var map = {
	"./hershey-choco.jpg": "3360",
	"./ovaltine.jpg": "8210",
	"./pancake-syrup.jpg": "242a",
	"./tang-orange.jpg": "a409",
	"./tang-pineapple.jpg": "76c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1d86";